import { NotificationsView } from '../features/notifications/NotificationsView.tsx'

export function NotificationsPage() {
  return (
    <div className="mx-auto w-full max-w-800 flex-1 p-16 pb-100 xl:pb-40 2xl:max-w-1200 2xl:p-32 2xl:pb-56 2xl:text-18">
      <NotificationsView />
    </div>
  )
}
